import { render } from "./SetLocales.vue?vue&type=template&id=67cd1334"
import script from "./SetLocales.vue?vue&type=script&lang=js"
export * from "./SetLocales.vue?vue&type=script&lang=js"

import "./SetLocales.vue?vue&type=style&index=0&id=67cd1334&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__